import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route pathname changes.
 * Mount once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset scroll for new screen — instant to avoid visual jump after animation
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // Reset main scroll containers as well (in case of nested scroll)
    document.scrollingElement && (document.scrollingElement.scrollTop = 0);
  }, [pathname]);
  return null;
}
